import React from 'react';

const NewsPage = () => {
  const allNewsItems = [];

  const categories = ["All", ...new Set(allNewsItems.map(item => item.category))];
  const [selectedCategory, setSelectedCategory] = React.useState("All");
  const [email, setEmail] = React.useState("");
  const [subscribeStatus, setSubscribeStatus] = React.useState("");

  const filteredNews = selectedCategory === "All"
    ? allNewsItems
    : allNewsItems.filter(item => item.category === selectedCategory);

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      setSubscribeStatus("Please enter a valid email address.");
      return;
    }

    // Show success message without sending email
    setSubscribeStatus("Thank you for subscribing!");
    setEmail("");
    setTimeout(() => setSubscribeStatus(""), 3000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            News & Updates
          </h1>
          <div className="w-32 h-1 bg-gradient-to-r from-blue-600 to-indigo-700 mx-auto mb-8 rounded-full"></div>
          <p className="max-w-4xl mx-auto text-xl text-gray-600 leading-relaxed">
            Stay informed about Baniuaga Group's latest developments, achievements, and strategic initiatives driving growth across Timor-Leste.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                selectedCategory === category
                  ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200 hover:border-blue-300'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {filteredNews.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredNews.map((item) => (
              <article key={item.id} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
                <div className="relative">
                  <div className="w-full h-48 bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center">
                    <svg className="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                    </svg>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-800 group-hover:bg-blue-100 group-hover:text-blue-800 transition-colors duration-300">
                      {item.category}
                    </span>
                    <time className="text-sm text-gray-500">
                      {item.date}
                    </time>
                  </div>
                  
                  <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-700 transition-colors duration-300 line-clamp-2">
                    {item.title}
                  </h2>
                  
                  <p className="text-gray-600 leading-relaxed mb-4 line-clamp-3">
                    {item.content}
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500">
                      By {item.author}
                    </span>
                    <button className="flex items-center text-blue-600 group-hover:text-blue-700 transition-colors duration-300 font-semibold">
                      <span className="text-sm">Read More</span>
                      <svg className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center py-16">
            <p className="text-gray-500 text-lg">No news articles available at this time.</p>
          </div>
        )}

        <div className="flex justify-center mt-16">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-8 rounded-xl text-center max-w-2xl w-full">
            <h3 className="text-2xl font-bold mb-4">Stay Updated</h3>
            <p className="text-blue-100 mb-6">
              Subscribe to our newsletter to receive the latest news and updates from Baniuaga Group.
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-white"
                required
              />
              <button type="submit" className="bg-white text-blue-600 font-semibold px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors duration-300 whitespace-nowrap">
                Subscribe Now
              </button>
            </form>
            {subscribeStatus && (
              <p className={`mt-4 text-sm font-medium ${subscribeStatus.includes('valid') ? 'text-red-200' : 'text-white'}`}>
                {subscribeStatus}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsPage;